
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  heroData: {
    title: "Discover Your Perfect Skincare Journey",
    subtitle: "Personalized skincare and wellness recommendations tailored to your unique skin type and lifestyle",
    backgroundImage: "/images/landing.jpg"
  },
  loading: false,
  error: null
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    updateHeroData: (state, action) => {
      state.heroData = { ...state.heroData, ...action.payload };
    }
  }
});

export const {
  setLoading,
  setError,
  updateHeroData
} = appSlice.actions;

export default appSlice.reducer;